import { DotProps } from "recharts";
import { LocalPostOfficeDot, MailDot } from "../../Atoms";
import CalendarDot from "../../Atoms/CalendarDot";
import { GraphIconType, IGraphDotStat, IGraphDotStats } from "../../types";

interface ICustomDot extends DotProps {
  handleMouseLeave: () => void;
  handleMouseEnter: (
    e: React.MouseEvent<SVGSVGElement>,
    stats: IGraphDotStat
  ) => void;
  payload?: {
    name: string;
  };
  graphEventStats: IGraphDotStats;
}

const CustomizedDot = (props: ICustomDot) => {
  const {
    cx,
    cy,
    handleMouseEnter,
    handleMouseLeave,
    graphEventStats,
    payload,
  } = props;
  // show one of two custom dots based on mailing type

  // without a CY there is no data point to plot
  if (payload?.name && graphEventStats?.[payload?.name]?.type && cy) {
    const graphEvent = graphEventStats[payload.name];
    switch (graphEventStats[payload.name].type) {
      case GraphIconType.Additional:
      default:
        return (
          <LocalPostOfficeDot
            cx={(cx || 0) - 26}
            cy={(cy || 0) - 26}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            dotStats={graphEvent}
          />
        );
      case GraphIconType.ProxyMessage:
        return (
          <MailDot
            cx={(cx || 0) - 26}
            cy={(cy || 0) - 26}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            dotStats={graphEvent}
          />
        );
      case GraphIconType.CalendarEvent:
        return (
          <CalendarDot
            cx={(cx || 0) - 26}
            cy={(cy || 0) - 26}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            dotStats={graphEvent}
          />
        );
    }
  }
  return null;
};

export default CustomizedDot;
